import { isNumber } from 'lodash';
import { add, bignumber, divide, subtract } from 'mathjs';

export const sumSafe = (
  num1: string | number | undefined | null,
  num2: string | number | undefined | null,
): number => {
  const isValidNum1 = isNumber(Number(num1)) && !isNaN(Number(num1));
  const isValidNum2 = isNumber(Number(num2)) && !isNaN(Number(num2));

  if (!isValidNum1 && !isValidNum2) {
    return 0;
  }

  if (!isValidNum1) {
    return Number(num2);
  }

  if (!isValidNum2) {
    return Number(num1);
  }

  return add(bignumber(Number(num1)), bignumber(Number(num2))).toNumber();
};

export const subtractionSafe = (
  minuend: string | number | undefined | null,
  subtrahend: string | number | undefined | null,
): number => {
  const isValidNum1 = isNumber(Number(minuend)) && !isNaN(Number(minuend));
  const isValidNum2 =
    isNumber(Number(subtrahend)) && !isNaN(Number(subtrahend));

  if (!isValidNum1 && !isValidNum2) {
    return 0;
  }

  if (!isValidNum1) {
    return Number(subtrahend);
  }

  if (!isValidNum2) {
    return Number(minuend);
  }

  return subtract(bignumber(Number(minuend)), bignumber(Number(subtrahend))).toNumber();
};

export const sumNumbers = (num1: number, num2: number): number =>
  add(Number(num1), Number(num2));

export const subtractNumbers = (minuend: number, subtrahend: number): number =>
  subtract(Number(minuend), Number(subtrahend));

export const divideSafe = (
  dividend: string | number | undefined | null,
  divisor: string | number | undefined | null,
): number => {
  const isValidDividend =
    isNumber(Number(dividend)) && !isNaN(Number(dividend));
  const isValidDivisor = isNumber(Number(divisor)) && !isNaN(Number(divisor));

  if (!isValidDividend && !isValidDivisor) {
    return 0;
  }

  if (!isValidDividend) {
    return 0;
  }

  if (!isValidDivisor || Number(divisor) === 0) {
    return 0;
  }

  return Number(divide(bignumber(Number(dividend)), bignumber(Number(divisor))));
};
